import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: 'psc-switch',
  templateUrl: './switch.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
  ],
})
export class SwitchComponent implements ControlValueAccessor, OnInit {
  @Input() disabled = false;
  @Input() checkedLabel: string;
  @Input() uncheckedLabel: string;
  @Input() tabIndex: number | null = null;
  @Input() labelClass: string = '';

  checked = false;
  onChange: any = () => {
  };
  onTouch: any = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
  }

  writeValue(checked: boolean) {
    this.checked = checked;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onNgModelChange(e: boolean) {
    this.checked = e;
    this.onChange(e);
  }
}
